import { ScrollReveal, StaggerContainer, StaggerItem } from "./animations/ScrollReveal";

function Section({
  id,
  title,
  subtitle,
  children,
  className = "",
  background = "white",
  image = null, 
  imageAlt = "Section illustration",
  imagePosition = "right",
}) {
  const bgClasses = {
    white: "bg-white",
    gray: "bg-accent-50",
    pattern: "bg-accent-50 bg-grid-pattern",
  };

  return (
    <section
      id={id}
      className={`py-16 md:py-24 ${bgClasses[background]} ${className}`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        {(title || subtitle) && (
          <ScrollReveal delay={0.1} className="text-center mb-12 md:mb-16">
            {title && <h2 className="section-title mb-4">{title}</h2>}
            {subtitle && <p className="section-subtitle">{subtitle}</p>}
          </ScrollReveal>
        )}

       
        {image ? (
          <StaggerContainer className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
            imagePosition === "left" ? "lg:grid-flow-col-dense" : ""
          }`}>
            {imagePosition === "left" && (
              <StaggerItem>
                <img
                  src={image}
                  alt={imageAlt}
                  className="rounded-2xl shadow-lg w-full object-cover"
                />
              </StaggerItem>
            )}

            <StaggerItem>{children}</StaggerItem>

            {imagePosition === "right" && (
              <StaggerItem>
                <img
                  src={image}
                  alt={imageAlt}
                  className="rounded-2xl shadow-lg w-full object-cover"
                />
              </StaggerItem>
            )}
          </StaggerContainer>
        ) : (
          <StaggerContainer>{children}</StaggerContainer>
        )}
      </div>
    </section>
  );
}

export default Section;
